import React from "react";
import { useActivityCoreData } from "src/hooks/useActivityCoreData";
import { userRole } from "src/service/config";

interface Props {
  data: ReturnType<typeof useActivityCoreData>;
}

const ActivityCore: React.FC<Props> = ({ data }) => {
  const {
    coreData,
    setInstruction,
    setLocalizedInstruction,
    setDifficulty,
    setIsActive,
    setNewKeyword,
    setActivityNumber,
    addKeyword,
    removeKeyword,
    tags,
    newKeyword,
  } = data;

  return (
    <>
      <div className="grid sm:grid-cols-3 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-700">
            Instruction
          </label>
          <input
            value={coreData.instruction}
            onChange={(e) => setInstruction(e.target.value)}
            className="input-style mt-1"
            placeholder="Enter main instruction"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-700">
            Localized Instruction
          </label>
          <input
            value={coreData.localizedInstruction}
            onChange={(e) => setLocalizedInstruction(e.target.value)}
            className="input-style mt-1"
            placeholder="Translate instruction"
            required
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-700">
            Difficulty Level
          </label>
          <select
            value={coreData.difficulty}
            onChange={(e) => setDifficulty(e.target.value)}
            className="input-style"
            required
          >
            <option value="" disabled>
              {" "}
              Select level{" "}
            </option>{" "}
            <option value="A1">A1 - Beginner</option>{" "}
            <option value="A2">A2 - Elementary</option>{" "}
            <option value="B1">B1 - Intermediate</option>{" "}
            <option value="B2">B2 - Upper Intermediate</option>{" "}
            <option value="C1">C1 - Advanced</option>
          </select>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 w-full gap-4 mt-4">
        <div className="flex items-center gap-2 mt-6">
          {["admin", "editor"].includes(userRole) && (
            <div className="flex gap-6 mb-4">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={coreData?.isActive}
                  onChange={(e) => {
                    setIsActive(e.target.checked);
                  }}
                />
                <span>Available</span>
              </label>
            </div>
          )}
        </div>

        <div className="mb-2">
          <label className="flex items-center gap-2">Activity Number</label>
          <input
            type="number"
            required
            placeholder="Enter Activity Number"
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
            value={coreData.activityNumber}
            onChange={(e) => {
              setActivityNumber(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="w-full">
        <div>
          <label className="text-sm font-medium text-gray-700">Tags</label>
          <div className="flex flex-wrap gap-2 mb-2 mt-1">
            {tags.map((tag, i) => (
              <span
                key={i}
                className="flex items-center bg-blue-100 text-brand text-xs px-2 py-1 rounded-full"
              >
                {tag}
                <button
                  onClick={() => removeKeyword(i)}
                  className="ml-1 text-brand"
                >
                  ✕
                </button>
              </span>
            ))}
          </div>
          <input
            type="text"
            value={newKeyword}
            onChange={(e) => setNewKeyword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === ",") {
                e.preventDefault();
                if (newKeyword.trim()) {
                  addKeyword(newKeyword.trim());
                  setNewKeyword("");
                }
              }
            }}
            placeholder="Type keyword and press enter"
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
          />
        </div>
      </div>
    </>
  );
};

export default ActivityCore;
